import { getAllQuestionnaireAnswers } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { EncounterAnswersLinkIds } from "@/encounters/constants/questionnaire-questions";
import { stripHtmlTags } from "@/utils/regex";

import { AmendmentCardGroup } from "./AmendmentCardGroup";

export const EncounterSummaryDifference = ({
  currentVersion,
  previousVersion,
}: {
  currentVersion?: QuestionnaireResponse;
  previousVersion?: QuestionnaireResponse;
}) => {
  if (!currentVersion || !previousVersion) return null;

  const currentAnswers = getAllQuestionnaireAnswers(currentVersion);
  const previousAnswers = getAllQuestionnaireAnswers(previousVersion);

  const currentSummaryNote = stripHtmlTags(
    currentAnswers[EncounterAnswersLinkIds.ClientSummary]?.[0]?.valueString,
  );
  const previousSummaryNote = stripHtmlTags(
    previousAnswers[EncounterAnswersLinkIds.ClientSummary]?.[0]?.valueString,
  );

  return (
    <AmendmentCardGroup
      cardTitle="Updated"
      currentVersion={currentSummaryNote}
      title="Client Summary & Instructions"
      previousVersion={previousSummaryNote}
    />
  );
};
